module.exports = __webpack_public_path__ + "static/Verne7-dd74ce3e6db963a8af8c46110f5eb65c.webp";